import * as React from "react";
import {ChromePicker, ColorResult} from "react-color";
import {Icon, Input} from "antd";

import styles from './ColorInput.module.less'
import {ChangeEvent} from "react";

export interface IPriceInputProps {
    value?: string;
    onChange?: (color: string) => void;
    disabled?: boolean;
    allowClear?: boolean;
}

export interface IState {
    picking: boolean;
    color?: string;
}

class ColorInput extends React.Component<IPriceInputProps, IState> {
    constructor(props: IPriceInputProps) {
        super(props);

        this.state = {
            picking: false,
            color: this.props.value
        }
    }

    handlePick = (color: ColorResult) => {
        this.setState({
            color: color.hex
        })
        if (this.props.onChange) {
            this.props.onChange(color.hex)
        }
    }

    handleOpen = () => {
        this.setState({picking: true})
    }

    handleClose = () => {
        this.setState({picking: false})
    }

    onChangeInput = (event: ChangeEvent<HTMLInputElement>) => {
        if (event.target.value === "") {
            this.setState({
                color: 'transparent'
            })
            if (this.props.onChange) {
                this.props.onChange('')
            }
        }
    }


    render() {
        return (
            <span>
                <Input
                    className={styles.input}
                    style={{"color": this.props.value}}
                    addonAfter={<Icon type={"bg-colors"} theme={"outlined"} style={{fontSize: "18px", color: this.props.value }}/>}
                    value={this.props.value}
                    onClick={this.handleOpen}
                    disabled={this.props.disabled}
                    allowClear={!this.props.disabled || this.props.allowClear || false}
                    onChange={this.onChangeInput}
                />
                {
                    this.state.picking &&
                    <div className={styles.popover}>
                        <div className={styles.cover} onClick={this.handleClose}/>
                        <ChromePicker
                            color={this.props.value}
                            onChangeComplete={this.handlePick}
                        />
                    </div>
                }
            </span>
        );
    }
}

export default ColorInput;